import * as types from './types'
import { createReducer } from 'app/state/utils'
import { FacilityReverseParams } from 'app/models/facility-reverse-params'

export interface FacilityReverseState {
  facilityReverses: FacilityReverseParams[]
  isLoading: boolean
}

const initialState: FacilityReverseState = {
  facilityReverses: [],
  isLoading: false,
}

const facilityReversesReducer = createReducer(initialState)({
  [types.GET_FACILITY_REVERSES]: (state: any, payload: any) => {
    return { ...state, facilityReverses: payload.payload }
  },

  [types.EDIT_FACILITY_REVERSE]: (state: any, payload: any) => {
    const index = state.facilityReverses.findIndex(
      (facilityReverse: { id: any }) => facilityReverse.id === payload.payload.data.id
    )
    const newArray = [...state.facilityReverses]
    newArray[index] = { ...payload.payload.data, status: 'Draft' }
    return {
      ...state,
      facilityReverses: newArray,
    }
  },

  [types.ADD_FACILITY_REVERSE]: (state: any, payload: any) => {
    return {
      ...state,
      facilityReverses: [
        { ...payload.payload.data, status: 'Draft' },
        ...state.facilityReverses,
      ],
    }
  },

  [types.SUBMIT_FACILITY_REVERSE]: (state: any, payload: any) => {
    const obj = state.facilityReverses.find(
      (facilityReverse: { id: any }) => facilityReverse.id == payload.payload.id
    )
    if (obj) obj.status = 'Submitted'
    return {
      ...state,
      facilityReverses: [...state.facilityReverses],
    }
  },

  [types.APPROVE_FACILITY_REVERSE]: (state: any, payload: any) => {
    const obj = state.facilityReverses.find(
      (facilityReverse: { id: any }) => facilityReverse.id == payload.payload.id
    )
    if (obj) obj.status = 'Approved'

    return {
      ...state,
      facilityReverses: [...state.facilityReverses],
    }
  },

  [types.REJECT_FACILITY_REVERSE]: (state: any, payload: any) => {
    const obj = state.facilityReverses.find(
      (facilityReverse: { id: any }) => facilityReverse.id == payload.payload.id
    )
    if (obj) obj.status = 'Draft'
    return {
      ...state,
      facilityReverses: [...state.facilityReverses],
    }
  },

  [types.DELETE_FACILITY_REVERSE]: (state: any, payload: any) => {
    const index = state.facilityReverses.findIndex(
      (facilityReverse: { id: any }) => facilityReverse.id == payload.payload.id
    )
    if (index >= 0) {
      state.facilityReverses.splice(index, 1)
    }
    return {
      ...state,
      facilityReverses: [...state.facilityReverses],
    }
  },
  [types.START_LOADING_FACILITY_REVERSE]: (state: any) => {
    return { ...state, isLoading: true }
  },
  [types.STOP_LOADING_FACILITY_REVERSE]: (state: any) => {
    return { ...state, isLoading: false }
  },
})

export default facilityReversesReducer
